import React from "react";

import { faLightbulb } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components/macro";

import { Clickable } from "components/Button";

export const LoadAllWrapper = styled.p`
  background-color: #ffffff;
  padding: 9px;
  margin: 0;
  margin-right: auto;
  margin-left: auto;
  border-radius: 4px;
  ${({ fullWidth }) => fullWidth && `width: 100%`}
`;

export const AllLoadedWrapper = styled.span`
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: auto;
  margin-left: auto;
`;

export const LoadAllTextWrapper = styled.span`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const LoadAll = ({
  allLoaded,
  text,
  onClick,
  buttonText = "Load All",
  icon = faLightbulb,
  fullWidth = false,
  dataTour = "load-all",
}) => {
  return !allLoaded ? (
    <LoadAllWrapper fullWidth={fullWidth}>
      <FontAwesomeIcon icon={icon} />
      &nbsp; &nbsp; {text} &nbsp;
      <Clickable onClick={onClick} data-tour={dataTour}>
        <LoadAllTextWrapper>{buttonText}</LoadAllTextWrapper>&nbsp;
      </Clickable>
    </LoadAllWrapper>
  ) : (
    <AllLoadedWrapper />
  );
};
